"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertResponseToClientSettings = exports.convertClientSettingValue = void 0;
function convertClientSettingValue(value) {
    return JSON.stringify(value);
}
exports.convertClientSettingValue = convertClientSettingValue;
function convertResponseToClientSettings(response) {
    if (!response.gambler || !response.gambler.settings)
        return {};
    return response.gambler.settings.reduce(function (sum, currentPair) {
        var parsedValue;
        try {
            parsedValue = JSON.parse(currentPair.value);
        }
        catch (err) {
            console.warn('can not parse gambler setting pair: ', currentPair);
            return sum;
        }
        sum[currentPair.name] = parsedValue;
        return sum;
    }, {});
}
exports.convertResponseToClientSettings = convertResponseToClientSettings;
//# sourceMappingURL=utils.js.map